import React from 'react';
import { usePage } from '../contexts/PageContext';
import SEO from '../components/SEO';

function LegalLayout({ pageKey }) {
  const { t, seo } = usePage(pageKey);
  const sections = (t('sections', '') || '').split('||').map((s) => s.trim()).filter(Boolean);
  const pairs = [];
  for (let i = 0; i < sections.length; i += 2) {
    pairs.push([sections[i], sections[i+1] || '']);
  }
  return (
    <>
      <SEO title={seo.title} description={seo.description} keywords={seo.keywords} />
      <section className="pt-24 pb-16 lg:pt-36 lg:pb-20">
        <div className="container-x max-w-[900px]">
          <h1 className="heading-display text-[44px] lg:text-[80px]">{t('title', 'Legal')}</h1>
          <p className="mt-4 text-xs uppercase tracking-[0.28em] text-[#C6C4CF]">{t('updated', '')}</p>
          <p className="mt-10 text-[17px] leading-relaxed text-[#C6C4CF]">{t('intro', '')}</p>
          <div className="mt-12 space-y-10 border-t border-[#3A332A] pt-10">
            {pairs.map(([title, body], i) => (
              <div key={i}>
                <h2 className="heading-display text-2xl lg:text-3xl">{title}</h2>
                <p className="mt-3 text-[#C6C4CF] leading-relaxed">{body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export function TermsPage() { return <LegalLayout pageKey="terms" />; }
export function PrivacyPage() { return <LegalLayout pageKey="privacy" />; }
export function CookiesPage() { return <LegalLayout pageKey="cookies" />; }
